import { cn } from '@/utils/cn';

export const RedditLogo = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			className={cn('w-6', className)}
			viewBox="0 0 24 24"
			fill="currentColor"
		>
			<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5.8 11.33c.02.16.03.33.03.5 0 2.55-2.97 4.63-6.63 4.63-3.65 0-6.62-2.07-6.62-4.63 0-.17.01-.34.03-.5a1.42 1.42 0 0 1-.53-1.09 1.45 1.45 0 0 1 2.47-1.03c1.15-.82 2.73-1.35 4.5-1.41l.84-3.96c.02-.08.06-.15.13-.2a.27.27 0 0 1 .23-.04l2.81.6a1.04 1.04 0 1 1-.11.52l-2.52-.53-.75 3.55c1.73.07 3.27.6 4.4 1.41a1.44 1.44 0 0 1 2.46 1.03c0 .42-.19.8-.48 1.06l-.25.09zM9.25 12.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm5.5 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5zm-5.47 3.85a.31.31 0 0 0 .44 0c.48-.48 1.2-.71 2.28-.71h.02c1.08 0 1.8.23 2.28.71a.31.31 0 1 0 .44-.44c-.6-.6-1.48-.89-2.72-.89h-.02c-1.24 0-2.12.3-2.72.89a.31.31 0 0 0 0 .44z" />
		</svg>
	);
};
